<template>
  <div>
    <div
      class="content product-detail"
      :class="{
        'h5-product-detail': isH5,
        'pc-product-detail': !isH5,
        'elec--product-detail': isElectron || isMGAppInPad,
        'H5-group-course-page': handleCourseCard.name === 'H5GroupCourse',
        'pad-app-product-detail': isMGAppInPad && isH5,
      }"
    >
      <div class="product-top">
        <!-- 概要信息 -->
        <component
          ref="courseCard"
          @jumpLoginPage="jumpLoginPage"
          :product-info="productInfo"
          :canTrialLseeon="canTrialLseeon"
          :isH5="isH5"
          :couponInfo="couponInfo"
          @signUp="signUp"
          :is="handleCourseCard.components"
        />
        <!-- 拼团列表 -->
        <GroupList
          v-if="groupList.length"
          :totalJoinNum="totalJoinNum"
          :groupList="groupList"
          :isJoiningGroup="isJoiningGroup"
          :isH5="isH5"
          @signUpByJoin="signUp"
        />
        <!-- 联报入口 -->
        <JointPurchase
          v-if="
            productInfo.union_info &&
            productInfo.union_info.activityStatus === 2
          "
          :jointInfo="productInfo.union_info"
        />
        <!-- 3天内的直播课程 -->
        <ThreeDaysLiveLesson
          @jumpLoginPage="jumpLoginPage"
          v-if="!isH5 && inThreeDaysLiveLesson?.length"
          :lessonList="inThreeDaysLiveLesson"
          :assistant="productInfo.assistant || {}"
          :haveAssistant="productInfo.assistant_state === 1"
        />
        <!-- 机构信息 -->
        <OrgCard
          :orgInfo="orgInfo"
          :isH5="isH5"
          :orgId="productInfo.org_id || ''"
        />
        <!-- tab -->
        <div class="tab-box">
          <div
            :class="{
              'tabs-fixed': detailNavFixed,
              'electron-tab-fixed': isElectron,
            }"
            :style="'top:' + tabFixTop + 'px'"
          >
            <ul class="tabs-wrap">
              <li
                v-for="item in sortTabListById"
                :key="item.id"
                :class="{
                  active: item.id === activeId,
                  'course-tab':
                    item.id === 2 &&
                    canTrial &&
                    productInfo.enrollment === null,
                }"
                @click="changeTab(item)"
              >
                {{ item.title }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="tabs-cont">
        <!-- 详情 -->
        <div class="tab-content ql-snow" ref="detail">
          <CourseDescription
            :isH5="isH5"
            :courseDescription="productInfo.course_description || ''"
          />
        </div>

        <!-- 课程 -->
        <div class="tab-content course-cont" ref="course">
          <div>
            <div class="lesson-list">
              <div class="course-card" v-if="!isH5 && false">
                <img
                  class="cover"
                  :src="productInfo.cover_url + '?imageView2/0/w/320'"
                  alt="课程图片"
                />
                <div class="lesson-info">
                  <p class="title">
                    {{ productInfo.course_name }}
                  </p>
                  <p class="lesson-num">
                    <span>{{ productInfo.lessonNum }}课时</span>
                    <span
                      >（{{ productInfo.liveNum }}直播，{{
                        productInfo.vidoeNum
                      }}点播，{{ productInfo.workNum }}作业）</span
                    >
                  </p>
                </div>
              </div>
              <component
                :is="handleLessonListCom"
                :isRegistered="productInfo.enrollment !== null"
                :unitList="productInfo.unit_list || []"
              />
            </div>
          </div>
        </div>

        <!-- 评价 -->
        <div class="tab-content comment-cont" ref="comment">
          <CommentList
            @jumpLoginPage="jumpLoginPage"
            @commentTotal="handleCommentTotal"
            :course_id="this.productInfo.id"
          />
        </div>
      </div>

      <!-- 推荐课程 -->
      <div class="tab-content recommend-cont" ref="recommend">
        <template v-if="orgRecommendCourse.length">
          <p class="recommend-title">推荐课程</p>
          <div class="recommend-course-wrap">
            <OrgCourseCard
              v-for="(item, index) in orgRecommendCourse"
              :key="item.id + index"
              :courseInfo="item"
            />
          </div>
        </template>
      </div>

      <!-- 温馨提示 -->
      <TipsText :orgInfo="orgInfo" />

      <!-- 底部报名 -->
      <FixBottom
        :productInfo="productInfo"
        :orgInfo="orgInfo"
        @signUp="signUp"
        :showBottomCountdown="showBottomCountdown"
        :isJoiningGroup="isJoiningGroup"
        :userGroupInfo="userGroupInfo"
      />
      <!-- 课程-小助手 -->
      <CourseHelper
        v-if="showCourseHelper"
        :assistant="productInfo.assistant || {}"
        :guide="productInfo.guide"
        :courseId="productInfo.id"
      />
    </div>
    <div id="confirm-order-container"></div>
  </div>
</template>

<script>
import ThreeDaysLiveLesson from "./three-days-live-lesson/Index";
import OrgCourseCard from "@saas/pages/src/home/components/CourseCard";
import H5LessonList from "./lesson-list/H5LessonList";
import CommentList from "./components/CommentList";
import Vue from "vue";
import Confirm from "@saas/components/src/components/confirm-order/index";
Vue.use(Confirm);
import { GroupCountDown } from "@saas/components/src";
import CourseDescription from "./components/CourseDescription";
import TipsText from "./components/TipsText";
import JointPurchase from "./components/JointPurchase";
import LessonList from "./lesson-list/LessonList.vue";
import OrgCard from "./components/OrgCard";
import H5GroupCourse from "@saas/pages/src/product-details/course-card/H5GroupCourse";
import CourseCard from "@saas/pages/src/product-details/course-card/CourseCard";
import FixBottom from "@saas/pages/src/product-details/fix-bottom/Index.vue";
import FooterOrgInfo from "./components/FooterOrgInfo";
import {
  isH5,
  isHXApp,
  isWeChat,
  isWebPageInElectron,
  appendQueryParamsToUrl,
  isMGAppInPad,
  CourseHelper,
  compareVersion,
} from "@saas/components/src";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { mapGetters } from "vuex";
import {
  handleDuration,
  million,
  pageShare,
} from "@saas/components/src/utils/utils";
import moment from "moment";
import {
  getOrganizationHome,
  getOrganization,
} from "@saas/server-api/src/organization";
import {
  getCourseInfo,
  createEnrollment,
  getByCourseId,
} from "@saas/server-api/src/product-details";
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import { EventBus } from "@saas/components/src/utils/event-bus";
import GroupList from "./components/GroupList";
import handleCourseInfo from "@saas/components/src/mixins/handleCourseInfo";
import { calPrice } from "@saas/server-api/src/joint-purchase/index";
import { getUserInfo } from "@saas/server-api/src";
import types from "@saas/store/src/types.js";
import courseQuickBar from "@saas/components/src/mixins/courseQuickBar";
import { getCourseState, getCourseList } from "@saas/server-api/src/course";
export default {
  mixins: [handleCourseInfo, courseQuickBar],
  data: function () {
    return {
      orgRecommendCourse: [], //机构下的推荐课程
      showBottomCountdown: false,
      showBackbtn: !isHXApp() && !window.isElectron,
      million,
      isH5: isH5(),
      isHXApp: isHXApp(),
      isMGAppInPad: false,
      handleDuration,
      moment,
      tabList: [
        { id: 1, title: "详情", ref: "detail", class: "ql-snow" },
        { id: 2, title: "课程", ref: "course", class: "course-cont" },
      ],
      activeId: 1,
      lastTime: 0,
      detailNavFixed: false,
      canShowAllInfo: false, //是否可展开收起
      showAllStatus: false, //false:展开，true：收起
      productInfo: {}, //商品信息-activity_type:1优惠券 2限时促销 3:联报 4:拼团
      orgInfo: {}, //机构信息
      loading: false, //报名请求状态
      scrollLock: false, //点击锚点锁定，不触发滚动内容对导航的影响
      timer: null,
      promotionInfo: {},
      couponInfo: {},
      isChangeTab: false, //点击tab和监听滚动-高亮tab冲突
      tabFixTop: 0, //tab定位top值(客户端会被topbar遮盖)
      isElectron: window.isElectron,
      moreLink:
        "https://help.moguoyunke.com/guide/userguide.html#%E8%AF%BE%E7%A8%8B%E6%8A%A5%E5%90%8D",
      totalJoinNum: 0, //总参团人数
      groupList: [], //拼团列表
      isJoiningGroup: false, //当前用户正在拼团中（已付款）
      userGroupInfo: {}, //当前用户所在团信息
      isWebPageInElectron: isWebPageInElectron(),
      isWechat: isWeChat(),
    };
  },
  mounted() {
    this.isMGAppInPad = isMGAppInPad();
    this.isH5 = isH5();
    if (this.isHXApp) {
      jsToFlutter("getToken");
      EventBus.$off("setToken");
      EventBus.$on("setToken", (isLogin) => {
        // 获取页面信息
        this.apiGetCourseInfo();
      });
    } else if (this.isWebPageInElectron || this.isWechat) {
      getUserInfo().then((res) => {
        if (res.code === 1) {
          this.$store.commit(types.CHANGE_PROFILE, {
            profile: res.data,
          });
        }
      });
      this.apiGetCourseInfo();
    } else {
      this.apiGetCourseInfo();
    }
    this.$nextTick(() => {
      setTimeout(() => {
        if (window.isElectron) {
          let elMain = document.getElementById("electron-main");
          if (!elMain) return;
          elMain.addEventListener("scroll", this.scrollFunc, true);
          elMain.addEventListener("scroll", this.scrollActiveNav, true);
        } else {
          window.addEventListener("scroll", this.scrollFunc, true);
          window.addEventListener("scroll", this.scrollActiveNav, true);
        }
        if (this.$refs["detail"]) {
          this.canShowAllInfo = this.$refs["detail"].offsetHeight > 4000;
        }
      }, 0);
    });
  },
  destroyed() {
    //取消监听滚动置顶
    if (window.isElectron) {
      let elMain = document.getElementById("electron-main");
      if (!elMain) return;
      elMain.removeEventListener("scroll", this.scrollFunc, true);
      elMain.removeEventListener("scroll", this.scrollActiveNav, true);
    } else {
      window.removeEventListener("scroll", this.scrollFunc, true);
      window.removeEventListener("scroll", this.scrollActiveNav, true);
    }

    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    handleCommentTotal(val) {
      let index = this.tabList.findIndex((item) => {
        return item.id === 3;
      });
      if (index === -1) {
        this.tabList.push({
          id: 3,
          title: `评价(${val})`,
          ref: "comment",
          class: "comment-cont",
        });
      } else {
        this.tabList[index].title = `评价(${val})`;
      }
    },
    apiCalPrice(activity_id) {
      let { goods, activity_type } = this.productInfo;
      let params = {
        compute: false,
      };
      let activityId = ""; //活动id
      if (activity_type === 1 && this.couponInfo.id) {
        // 优惠券
        activityId = this.couponInfo.id;
        params.goods_items = [
          {
            goods_id: goods.id,
            // activity_type: 1,
            // activity_id: this.couponInfo.id,
          },
        ];
      } else if (activity_type === 2) {
        activityId = this.productInfo.promotion_info.id;
        // 促销
        params.goods_items = [
          {
            goods_id: goods.id,
            activity_type: 2,
            activity_id: this.productInfo.promotion_info.id,
          },
        ];
      } else if (activity_type === 4 && activity_id !== null) {
        // 拼团
        params.goods_items = [
          {
            goods_id: goods.id,
            activity_type: 4,
            activity_id,
          },
        ];
      } else {
        // 普通
        params.goods_items = [
          {
            goods_id: goods.id,
          },
        ];
      }
      calPrice(params).then((res) => {
        if (res.code === 1) {
          let calPriceData = res.data;
          calPriceData.activity_type = params.goods_items[0]?.activity_type;
          calPriceData.goods_items = params.goods_items;
          let user = this.user;
          document.querySelector(".product-detail").style.display = "none";
          this.$saasConfirmOrder(
            [],
            "confirm-order-container",
            calPriceData,
            user
          );
        } else if (res.code === 55005 && res.data?.order_no) {
          this.$chiralAutoMessage(`您已下单本商品，可继续完成支付`, 1200);
          setTimeout(() => {
            let url = `/confirm-order/${res.data.order_no}`;
            let params = {
              history: 1,
              goods_id: goods.id,
            };
            // 拼团-参团、开团
            if (activity_id !== null) {
              params.activity_id = activity_id;
              params.activity_type = 4;
            } else if (activity_type === 2) {
              // 促销
              params.activity_id = activityId;
              params.activity_type = 2;
            }
            //线索渠道参数
            let { course_id, lesson_id } = this.$route.query;
            if (course_id) {
              params.course_id = course_id;
              params.lesson_id = lesson_id;
            }
            url = appendQueryParamsToUrl(url, params);
            this.$router.push(url);
          }, 1200);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    scrollActiveNav(e) {
      if (this.isChangeTab) return;
      const scrollItems = document.querySelectorAll(".tab-content");
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (this.scrollLock) {
        this.timer = setTimeout(() => {
          this.scrollLock = false;
        }, 35);
        return;
      }
      for (let i = this.tabList.length - 1; i >= 0; i--) {
        var scrollTop =
          document.body.scrollTop ||
          document.documentElement.scrollTop ||
          e.target.scrollTop;
        if (scrollItems[i]?.offsetTop) {
          const judge = scrollTop >= scrollItems[i].offsetTop - 136;
          if (judge) {
            this.activeId = this.tabList[i].id;
            break;
          }
        }
      }
    },
    apiGetCourseInfo() {
      let course_id = this.$route.params.id;
      if (!course_id) return;
      getCourseInfo({ course_id }).then((res) => {
        if (res.code === 1) {
          if (res.data) {
            this.localSavePage(res.data);
            // 设置页面标题
            if (res.data?.course_name) {
              let title = res.data.course_name;
              document.title = title;
              jsToFlutter("setTitle", { title });
            }
            // 课程报名状态-停止 且 未报名
            if (
              res.data?.enrollment_state === 3 &&
              res.data?.enrollment === null
            ) {
              this.$chiralConfirmMessage("该课程已停止报名");
            }
            // 计算课时数-直播课状态处理
            this.productInfo = this.handleCourseInfoData(res.data || {});
            // 处理优惠券信息-已报名不处理、不展示
            if (res.data.coupon_info?.id && res.data.enrollment === null) {
              this.handleActivityInfo(res.data || {});
            }
            // 处理联报信息
            if (res.data?.union_info?.id) {
              // 处理活动状态：1：未开始，2：进行中，3：已结束
              let { begin_at, end_at } = res.data.union_info;
              let now = new Date().getTime();
              if (now < begin_at * 1000) {
                this.productInfo.union_info.activityStatus = 1;
              } else if (now > end_at * 1000) {
                this.productInfo.union_info.activityStatus = 3;
              } else {
                this.productInfo.union_info.activityStatus = 2;
              }
            }
            // 处理拼团信息
            if (res.data?.group_set_info?.id) {
              this.productInfo.activity_type = 4;
              // 处理活动状态：1：未开始，2：进行中，3：已结束
              let { start_time, real_end_time, end_time } =
                res.data.group_set_info;
              let end = end_time;
              if (real_end_time && real_end_time < end_time) {
                end = real_end_time;
              }
              this.productInfo.group_set_info.endTime = end;
              let now = new Date().getTime();
              if (now < start_time * 1000) {
                this.productInfo.group_set_info.activityStatus = 1;
              } else if (now > end * 1000) {
                this.productInfo.group_set_info.activityStatus = 3;
              } else {
                this.productInfo.group_set_info.activityStatus = 2;
                // 获取拼团列表
                this.apiGetByCourseId();
              }
            }
            // 限时促销
            if (res.data?.promotion_info?.id) {
              this.productInfo.activity_type = 2;
            }
            // 获取机构信息
            this.apiGetOrganization(res.data.org_id);
            if (!this.isH5) {
              // 获取机构推荐课程
              this.apiGetOrganizationHome(res.data.org_id);
            }
          }
        } else if (res.code === 4444) {
          this.$showErrorPage();
        } else if (res.code === 6666) {
          this.$showErrorPage({
            tips: "课程不存在",
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    apiGetOrganizationHome(org_id) {
      let params = {
        org_id,
        module_type: 4,
      };
      getOrganizationHome(params).then((res) => {
        if (res.code === 1) {
          if (res?.data?.length) {
            let orgRecommendCourse = [];
            res.data.forEach((item) => {
              if (item?.content_list?.length) {
                orgRecommendCourse = orgRecommendCourse.concat(
                  item?.content_list
                );
              }
            });
            // 去重
            let obj = {};
            orgRecommendCourse = orgRecommendCourse.reduce(function (
              item,
              next
            ) {
              //item为没有重复id的数组，next为当前对象
              obj[next.id] ? "" : (obj[next.id] = true && item.push(next));
              return item;
            },
            []);
            if (
              orgRecommendCourse?.length &&
              this.tabList.findIndex((item) => item.id === 4) === -1
            ) {
              this.tabList.push({
                id: 4,
                title: `推荐`,
                ref: "recommend",
                class: "recommend-cont",
              });
              let courseIds = orgRecommendCourse.map((course) => course.id);
              // 获取课程活动信息
              getCourseList({ course_id: courseIds.join(",") }).then((res) => {
                if (res.code === 1) {
                  // 排序
                  this.orgRecommendCourse = (res?.data?.list || []).sort(
                    (a, b) => {
                      return courseIds.indexOf(a.id) - courseIds.indexOf(b.id);
                    }
                  );
                  // 获取课程状态
                  this.apiGetCourseState(courseIds);
                }
              });
            }
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    apiGetCourseState(courseIds) {
      getCourseState({
        course_id: courseIds.join(","),
      }).then((res) => {
        if (res.code === 1 && res.data?.length) {
          let haveStatusIds = res.data.map((item) => item.course_id);
          this.orgRecommendCourse.forEach((course, index) => {
            if (haveStatusIds.includes(course.id)) {
              let { trial_state, live_state } = res.data.find(
                (element) => element.course_id === course.id
              );
              this.$set(this.orgRecommendCourse, index, {
                ...course,
                trial_state,
                live_state,
              });
            }
          });
        }
      });
    },
    apiGetByCourseId() {
      getByCourseId({ course_id: this.productInfo.id }).then((res) => {
        if (res.code === 1 && res.data?.length) {
          this.totalJoinNum = 0;
          let waitingGroupList = [];
          // 未登录-肯定未参团
          if (!this.isAuthenticated) {
            this.isJoiningGroup = false;
          } else if (this.productInfo.enrollment === null) {
            // 当前用户所在团信息
            let userGroupList = res.data.filter((item) => {
              return item.is_join_group && item.state === 1;
            });
            if (userGroupList[0]) {
              let userInfo = userGroupList[0].member_list.filter((member) => {
                return (
                  member.user_id === this.user.user_id && member.state === 2
                );
              });
              if (userInfo[0]) {
                // 已付款
                this.isJoiningGroup = true;
                this.userGroupInfo = userGroupList[0];
              }
            }
            console.log(this.userGroupInfo, userGroupList, "userGroupList");
          } else if (this.productInfo.enrollment !== null) {
            // 已报名
            this.isJoiningGroup = true;
          }
          res.data.forEach((item) => {
            // 待成团
            if (item.state === 1) {
              waitingGroupList.push(item);
              // 数据处理
              let leaderInfo = item.member_list.filter((member) => {
                return member.is_leader === 1;
              });
              if (leaderInfo?.length) {
                item.leaderInfo = leaderInfo[0];
                item.leaderInfo.nickname =
                  leaderInfo[0].nickname.substr(0, 1) + "***";
              }
              // 已支付-成员数
              let isPayed = item.member_list.filter((member) => {
                return member.state === 2;
              });
              item.diffNum = item.group_num - isPayed.length;
            }
            let numList = item.member_list.filter((member) => {
              return [2, 4].includes(member.state);
            });
            this.totalJoinNum += numList.length;
          });

          this.groupList = waitingGroupList.splice(0, 2);
        }
      });
    },
    // 处理活动信息
    handleActivityInfo(obj) {
      // 只处理公开发放
      if (obj.coupon_info && obj.coupon_info.distribution_method === 1) {
        let { id, coupon_type, amount, ratio } = obj.coupon_info;
        this.productInfo.activity_type = 1;
        if (coupon_type === 1) {
          // 立减
          let activityPrice = ((obj.goods.price - amount) / 100).toFixed(2);
          this.couponInfo = {
            id,
            amount: (amount / 100).toFixed(2),
            coupon_type,
            activityPrice,
          };
        } else if (coupon_type === 2) {
          // 折扣
          let activityPrice = ((obj.goods.price * (ratio / 100)) / 100).toFixed(
            2
          );
          this.couponInfo = {
            id,
            ratio: ratio / 10,
            coupon_type,
            activityPrice,
          };
        }
      }
    },
    apiGetOrganization(id) {
      getOrganization({ org_id: id }).then((res) => {
        if (res.code === 1 && res.data) {
          this.orgInfo = res.data;
          let title = document.title;
          let desc = "";
          let pic = res.data.org_logo;
          console.log({ title, desc, imgUrl: pic });

          pageShare(window.wx, { title, desc, imgUrl: pic });
        }
      });
    },
    // activity_id:活动ID，团购时，0表示开团，其余表示参团ID
    signUp(activity_id = null) {
      console.log(activity_id, "activity_id");
      console.log(this.isAuthenticated, "this.isAuthenticated");

      if (this.isAuthenticated) {
        // 登录
        if (this.loading) return;
        this.loading = true;
        if (this.productInfo.goods && this.productInfo.goods.fee_type === 1) {
          // 免费
          createEnrollment({ course_id: this.productInfo.id })
            .then((res) => {
              if (res.code === 1) {
                // 报名成功-通知app-更新学习课程列表
                if (this.isHXApp) {
                  jsToFlutter("joinSuccess");
                }
                this.apiGetCourseInfo();
                // 跳转到学习页面
                this.$chiralAutoMessage(`报名成功，即将跳转到学习页面~`, 1500);
                setTimeout(() => {
                  if (this.isHXApp) {
                    let params = {
                      courseId: this.productInfo.id,
                    };
                    let otherData = {
                      name: "myCourseDetail",
                    };
                    jsToFlutter("openPage", params, otherData);
                  } else {
                    this.$router.push({
                      name: "myCourseDetail",
                      params: { id: this.productInfo.id },
                    });
                  }
                }, 1500);
              } else {
                this.$message.error(res.message);
              }
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          // 付费
          this.apiCalPrice(activity_id);
        }
      } else {
        // 未登录
        this.jumpLoginPage();
      }
    },
    jumpLoginPage() {
      if (this.isHXApp) {
        jsToFlutter("login");
        console.log("jsToFlutter===login-product-detail");
      } else {
        // let preRoute = window.location.href;
        // window.location.href = `${process.env.VUE_APP_ADMIN_URL}/login?return_url=${preRoute}`;
        this.$loginDialog();
      }
    },
    changeTab(item) {
      this.isChangeTab = true;
      this.activeId = item.id;
      if (this.$refs[item.ref]) {
        this.$refs[item.ref].scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      setTimeout(() => {
        this.isChangeTab = false;
      }, 2000);
    },
    //滚动置顶
    scrollFunc(e) {
      var nowTime = Date.now();
      if (nowTime - this.lastTime) {
        this.lastTime = nowTime;
        // 导航
        if (document.querySelector(".topbar")) {
          // 客户端
          let height = document.querySelector(".topbar").offsetHeight;
          this.tabFixTop = height;
        } else if (document.querySelector(".nav-bar")) {
          // web
          let height = document.querySelector(".nav-bar").offsetHeight;
          this.tabFixTop = height;
        }
        let courseTopHeight =
          document.querySelector(".product-top")?.offsetHeight || 0;
        let courseTopOffsetTop =
          document.querySelector(".product-top")?.offsetTop || 0;

        const scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          e.target.scrollTop;
        this.detailNavFixed = scrollTop >= courseTopHeight + courseTopOffsetTop;

        // 底部倒计时
        let groupEl = document.getElementById("activity-group");
        if (this.productInfo.enrollment !== null || !groupEl) {
          return false;
        }
        let { offsetTop, offsetHeight } = groupEl;
        let top = offsetTop + offsetHeight;
        let coverHeight = document.querySelector("#h5-course-cover");
        if (isH5 && coverHeight) {
          top += coverHeight.offsetHeight;
        }
        if (scrollTop >= top) {
          this.showBottomCountdown = true;
        } else {
          this.showBottomCountdown = false;
        }
      }
    },
    // 点击查看更多
    viewMore() {
      window.open(this.moreLink);
    },
  },
  filters: {},
  computed: {
    ...mapGetters(["isAuthenticated", "user"]),
    sortTabListById() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.tabList.sort((a, b) => {
        return a.id - b.id;
      });
    },
    showCourseHelper() {
      if (this.isHXApp) {
        console.log(
          this.productInfo.assistant_state,
          compareVersion("1.10.0"),
          "compareVersion========="
        );
        return (
          this.productInfo.assistant_state === 1 &&
          [1, 0].includes(compareVersion("1.10.0"))
        );
      } else {
        return this.productInfo.assistant_state === 1;
      }
    },
    handleCourseCard() {
      if (this.isH5 && this.productInfo?.group_set_info?.activityStatus === 2) {
        return {
          name: "H5GroupCourse",
          components: H5GroupCourse,
        };
      } else {
        return {
          name: "CourseCard",
          components: CourseCard,
        };
      }
    },
    handleLessonListCom() {
      if (this.isH5) {
        return H5LessonList;
      } else {
        return LessonList;
      }
    },
  },
  components: {
    ThreeDaysLiveLesson,
    OrgCourseCard,
    GroupCountDown,
    CourseDescription,
    TipsText,
    CourseCard,
    OrgCard,
    LessonList,
    JointPurchase,
    GroupList,
    CommentList,
    FooterOrgInfo,
    FixBottom,
    H5LessonList,
    CourseHelper,
  },
};
</script>

<style lang="scss" scoped src="./electron-scss/index.scss"></style>
<style lang="scss" scoped>
.pc-product-detail {
  padding-top: 20px;
  max-width: 800px;
  width: 100%;
  padding-bottom: 140px;
  // 推荐课程
  .tab-content.recommend-cont {
    background: transparent;
    ::v-deep .pc-course-card {
      width: 262px;
      height: 310px;
      margin-right: 7px;
      padding: 12px 8px 16px;
      .cover-wrap {
        width: 100%;
        height: 138px;
      }
      .price-size-wrap {
        .active-price {
          font-size: 20px;
        }
        .unit,
        .decimal {
          font-size: 16px;
        }
      }
    }
    .pc-course-card:nth-child(3n) {
      margin-right: 0;
    }
  }
  .recommend-title {
    font-weight: 600;
    font-size: 30px;
    color: #0d1400;
    line-height: 42px;
    margin: 20px 0;
  }
  .recommend-course-wrap {
    width: 880px;
    display: flex;
    flex-wrap: wrap;
    .course-card {
      margin-right: 7px;
    }
  }
  .product-top {
    position: relative;
    z-index: 2;
  }
  .tab-box {
    height: 63px;
  }
  .ql-snow,
  .course-cont,
  .comment-cont,
  .recommend-cont {
    padding-top: 70px;
    margin-top: -70px;
    background: transparent !important;
  }
  .tabs-cont {
    padding-top: 70px;
    margin-top: -70px;
    background: #fff;
    padding-bottom: 15px;
    border-radius: 0 0 24px 24px;
    // overflow: hidden;
  }
  .go-back-wrap {
    padding: 14px 8px;
    display: flex;
    align-items: center;
    font-size: 14px;
    width: fit-content;
    cursor: pointer;
    img {
      width: 22px;
      height: 22px;
    }
    span {
      margin-left: 10px;
    }
  }
  .basic-info {
    border-radius: 8px 8px 0 0;
    background: #fff;
    padding: 20px;
    display: flex;
    .cover {
      width: 320px;
      height: 180px;
      margin-right: 8px;
      object-fit: cover;
    }
    .info-wrap {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      .title {
        font-size: 18px;
        line-height: 25px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        margin-bottom: 8px;
        word-break: break-all;
      }
      .validity-period {
        font-size: 12px;
        line-height: 17px;
        color: $chiral-light-text-color;
      }
      .activity-price-wrap {
        background: url("../../assets/images/activity-bg.png");
        background-size: 100% 100%;
      }
      .price-wrap {
        width: 372px;
        height: 58px;
        padding: 0 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        .left-wrap {
          display: flex;
          align-items: center;
        }
        .price {
          font-weight: 500;
          font-size: 18px;
          color: $chiral-price-color;
          line-height: 25px;
          margin-right: 40px;
        }
        .price.activity-price {
          color: $activity-color;
        }
        .STATS {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 16px;
          .num {
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            margin-bottom: 2px;
          }
          .text {
            font-weight: 400;
            font-size: 12px;
            color: $chiral-light-text-color;
            line-height: 17px;
          }
        }
        .course-card-btn {
          width: 88px;
          height: 32px;
          border-radius: 17px;
          font-size: 14px;
          padding: 0;
          line-height: 32px;
        }
      }
    }
  }
  .tabs-wrap {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 17px 34px;
    font-weight: 400;
    font-size: 16px;
    color: $plain-text-color;
    line-height: 22px;
    li {
      cursor: pointer;
      margin-right: 40px;
      padding-bottom: 7px;
    }
    .course-tab {
      position: relative;
      &::after {
        position: absolute;
        content: "免费试学";
        display: block;
        left: 50%;
        top: 28px;
        transform: translateX(-50%);
        width: 50px;
        height: 18px;
        font-weight: 600;
        font-size: 10px;
        color: #ffffff;
        line-height: 1;
        color: #ffffff;
        background: url("../../assets/images/product-details/try-tag.png");
        background-size: 100% 100%;
        text-align: center;
        padding-top: 5px;
      }
    }
    .active {
      position: relative;
      font-weight: 600;
      font-size: 16px;
      color: $saas-text-color;
      line-height: 22px;
      &::after {
        position: absolute;
        content: " ";
        display: block;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 16px;
        height: 3px;
        background: linear-gradient(
          132deg,
          $linear-gradient-begin 0%,
          $linear-gradient-end 100%
        );
        border-radius: 2px;
      }
    }
  }
  .tabs-fixed {
    position: fixed;
    width: 100%;
    z-index: 2;
    background: #ffffff;
    box-shadow: 0px 6px 16px 0px rgba(102, 116, 107, 0.1);
    left: 0;
    top: 0;
    .tabs-wrap {
      width: 100%;
      padding: 23px 28px 12px;
      max-width: 800px;
      margin: 0 auto;
    }
    li {
      padding-bottom: 11px;
    }
    .course-tab:not(.active) {
      position: relative;
      &::after {
        display: none !important;
      }
    }
  }
  .tab-content {
    background: #fff;
    // & > div {
    //   border-radius: 0 0 24px 24px;
    //   background: #fff;
    //   padding-bottom: 24px;
    // }
  }
  .course-cont > div {
    background: #fff;
    padding-bottom: 2px;
  }
  .ql-snow > div {
    background: #fff;
    padding: 0 16px 24px;
  }
  .product-info-wrap {
    max-height: 4000px;
    overflow: hidden;
  }
  .show-all {
    max-height: none;
  }
  .show-all-info {
    font-size: 14px;
    text-align: center;
    padding-top: 10px;
    span {
      cursor: pointer;
    }
    i {
      margin-left: 10px;
    }
  }
  .lesson-list {
    padding: 0 18px;
  }
  .tab-title {
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 25px;
    margin-bottom: 24px;
  }
  // .course-card {
  //   display: flex;
  //   align-items: center;
  //   border-radius: 8px;
  //   background: #fff;
  //   padding: 10px;
  //   border: 1px solid #ebebeb;
  //   box-shadow: 0 5px 11px rgba(163, 163, 163, 0.0588235294);
  //   margin-bottom: 20px;
  //   .cover {
  //     width: 160px;
  //     height: 90px;
  //     margin-right: 15px;
  //     object-fit: cover;
  //   }
  //   .lesson-info {
  //     flex: 1;
  //     width: 0;
  //   }
  //   .title {
  //     font-size: 16px;
  //     font-weight: 600;
  //     white-space: nowrap;
  //     overflow: hidden;
  //     text-overflow: ellipsis;
  //     margin-bottom: 15px;
  //   }
  //   .lesson-num {
  //     color: #95a1af;
  //   }
  // }

  .left-wrap {
    margin-right: 37px;
  }
  .price {
    font-weight: 600;
    font-size: 16px;
    color: $chiral-price-color;
    line-height: 22px;
  }
}

// 适配样式
.h5-product-detail {
  width: 100%;
  background: #fff;
  font-size: 0.37rem;
  padding-bottom: 2.35rem;
  min-height: 100vh;
  .go-back-wrap {
    display: flex;
    align-items: center;
    padding: 0.27rem 0.21rem;
    font-size: 0.3733rem;
    width: fit-content;
    img {
      width: 0.53rem;
      height: 0.53rem;
    }
    span {
      margin-left: 0.13rem;
    }
  }
  .tab-box {
    height: 0.72rem;
  }
  // 解决scrollview被吸顶部分遮盖问题
  .ql-snow,
  .course-cont,
  .comment-cont {
    padding-top: calc(1.07rem + #{$h5-open-app-height});
    margin-top: calc(-1.07rem - #{$h5-open-app-height});
    background: transparent !important;
  }

  // tab
  .tabs-wrap {
    background: #fff;
    display: flex;
    align-items: center;
    padding: 0 0 0.1rem 0.45rem;
    li {
      font-weight: 400;
      font-size: 0.37rem;
      color: #515350;
      line-height: 0.53rem;
      padding-bottom: 0.08rem;
      margin-right: 0.59rem;
      cursor: pointer;
    }
    .active {
      position: relative;
      font-weight: 600;
      color: $saas-text-color;
      &::after {
        position: absolute;
        content: " ";
        display: block;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 0.21rem;
        height: 0.05rem;
        border-radius: 0.03rem;
        background: linear-gradient(
          132deg,
          $linear-gradient-begin 0%,
          $linear-gradient-end 100%
        );
      }
    }
  }
  .tabs-fixed {
    position: fixed;
    width: 100vw;
    z-index: 2;
    background: #ffffff;
    box-shadow: 0rem 0.08rem 0.21rem 0rem rgba(102, 116, 107, 0.1);
    left: 0;
    top: $h5-open-app-height !important;
    .tabs-wrap {
      width: 100%;
      padding: 0.32rem 0 0.27rem 0.45rem;
      max-width: 100%;
      margin: 0 auto;
    }
  }

  .tab-content {
    background: #fff;
  }
  .course-cont > div {
    background: #fff;
    padding-bottom: 0.32rem;
  }
  .ql-snow > div {
    background: #fff;
    padding-bottom: 0.32rem;
  }
  .product-info-wrap {
    max-height: 4000px;
    overflow: hidden;
  }
  .show-all {
    max-height: none;
  }
  .show-all-info {
    text-align: center;
    font-size: 0.37rem;
    line-height: 0.53rem;
    padding: 0.43rem 0;
    i {
      margin-left: 0.25rem;
    }
  }
  .tab-title {
    font-weight: 600;
    font-size: 0.48rem;
    padding: 0.21rem;
  }
}

//electron
.electron-tab-fixed.tabs-fixed {
  width: calc(100% - #{$side-bar-width}) !important;
  left: $side-bar-width !important;
}
#electron-main {
  // 推荐课程
  .tab-content.recommend-cont {
    ::v-deep .electron-course-card {
      width: 250px;
      height: 262px;
      margin-right: 25px;
      .cover-wrap {
        width: 100%;
        height: 130px;
      }
    }
    .electron-course-card:nth-child(3n) {
      margin-right: 0;
    }
  }
  .ql-snow,
  .course-cont,
  .comment-cont,
  .recommend-cont {
    padding-top: 130px;
    margin-top: -130px;
    background: transparent !important;
  }
  .tabs-cont {
    padding-top: 130px;
    margin-top: -130px;
  }
  .course-tab::after {
    top: 22px !important;
  }
}

// 活动按钮样式
.activity-sign-up-btn {
  background: $activity-color;
  border-color: $activity-color;
}
.activity-sign-up-btn.el-button:hover,
.activity-sign-up-btn.el-button:focus {
  background: $activity-color !important;
  border-color: $activity-color !important;
  color: #fff;
}
</style>
<style>
.product-title-tooltip {
  max-width: 300px;
}
@media (max-width: 767px) {
  .product-title-tooltip {
    max-width: 90%;
  }
}
</style>
